const Consts = {
    GROUP_PARAM : "backParam",
    GROUP_HOME : "backHome",
    GROUP_CACHE : "cacheBack",
    GROUP_LABELS : "labelBack",
    TIER : "back",
}

export default Consts